import { render } from "./CategoryStatsCard.vue?vue&type=template&id=635b84d0&scoped=true"
import script from "./CategoryStatsCard.vue?vue&type=script&lang=js"
export * from "./CategoryStatsCard.vue?vue&type=script&lang=js"

import "./CategoryStatsCard.vue?vue&type=style&index=0&id=635b84d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635b84d0"]])

export default __exports__